import HttpClient from '../HttpService';

function getSummary() {
    return HttpClient.get('/dashboard/summary');
}

export default {
    getSummary
};
